module.exports = __webpack_public_path__ + "img/LineQrSeed.5f57cdaa.png";